import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import '../css/App.css';
import Navigation from "../component/Navigation";
import ShoppingCart from "../component/ShoppingCart";

const MobileHeader = React.lazy(() => import("../component/MobileHeader"));

const aStyle = { paddingRight: "3px", fontWeight: 700 };

interface IMainProps {
  children?: JSX.Element | JSX.Element[]
}

function MainLayout(props: IMainProps) {
  return (
    <Fragment>
      <Box sx={{ display: { xs: "none", lg: "block" }, position: "fixed", width: "400px", paddingTop: "50px", paddingLeft: "50px", textAlign: "left" }}>
        <Link
          color="inherit"
          style={{ textDecoration: 'none' }}
          to={"/"}
          component={RouterLink}
        >
          <img
            src="/logo/3d-white-web.png"
            alt="3d-white-logo"
            style={{ maxWidth: "200px" }}
          />
        </Link>
      </Box>
      <ShoppingCart />
      <Navigation />
      <MobileHeader />
      {props.children}
      <Grid container sx={{ display: { lg: "none", xs: "flex" }, justifyContent: "center", bottom: "0px" }}>
        <Grid item xs={12} textAlign="center">
          <Typography variant="body2">
            {'Copyright © 2022 Audio500'}
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mb: "10px" }} textAlign="center">
          <Typography variant='body2'>
            <a style={aStyle} target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/audio500_/">INSTAGRAM</a>
            <a style={aStyle} target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/audio500/">FACEBOOK</a>
            <a style={aStyle} target="_blank" rel="noopener noreferrer" href="https://www.carousell.sg/u/audio500/">CAROUSELL</a>
          </Typography>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default MainLayout;
